import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { SelectableFilterOption } from '../filter-categories-list/filter-categories-list.component';

/**
 * Events column: expandable event groups with sub-event options and a
 * select/deselect-all checkbox.
 */
@Component({
  selector: 'app-filter-events-list',
  templateUrl: './filter-events-list.component.html',
  styleUrls: ['./filter-events-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterEventsListComponent {
  @Input() events: SelectableFilterOption[] = [];
  @Input() subEvents: { [eventValue: string]: SelectableFilterOption[] } = {};
  @Input() control: UntypedFormControl;

  @Output() toggleAll = new EventEmitter<void>();
  @Output() toggleOption = new EventEmitter<SelectableFilterOption>();

  getTotalSubeventsCount(): number {
    if (!this.subEvents || !this.events) {
      return 0;
    }
    let total = 0;
    this.events.forEach((event) => {
      if (this.subEvents[event.value]) {
        total += this.subEvents[event.value].length;
      }
    });
    return total;
  }

  hasSelectedSubevents(eventValue: string): boolean {
    if (!this.subEvents || !this.subEvents[eventValue]) {
      return false;
    }
    return this.subEvents[eventValue].some((subevent) => subevent.selected);
  }

  eventsToggleTooltip(): string {
    if (this.control.value?.length !== this.getTotalSubeventsCount()) {
      return 'Select all events';
    } else {
      return 'Deselect all events';
    }
  }
}
